import { CSVStats } from "providers/ProgressContext/slices/UploadCsvSlice/types";
import { invalidKeys } from "./constants";

export const getInvalidItems = (
  stats?: CSVStats
): { title: string; value: string; originalValue: string }[] => {
  if (!stats) return [];

  return invalidKeys.reduce(
    (acc, { key, title }) => {
      if (stats[key])
        acc.push({ title, value: stats[key], originalValue: key });
      return acc;
    },
    [] as {
      title: string;
      originalValue: string;
      value: keyof CSVStats;
    }[]
  );
};
